module.exports = __webpack_public_path__ + "static/img/mobilefull.ca8cff6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Probuild/mobilefull.png
// module id = cOuQ
// module chunks = 0